import { useState, useEffect } from 'react';
import { Storage } from '../lib/storage';
import { COUNTRIES_CONFIG, type CountryConfig } from '../lib/countryConfig';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const useCountry = () => {
  const [selectedCountry, setSelectedCountry] = useState<string>(() => {
    return Storage.get('motopikis_country') || 'CO';
  });

  const [config, setConfig] = useState<CountryConfig>(() => {
    return COUNTRIES_CONFIG[selectedCountry] || COUNTRIES_CONFIG.CO;
  });

  useEffect(() => {
    const activeConfig = COUNTRIES_CONFIG[selectedCountry] || COUNTRIES_CONFIG.CO;
    setConfig(activeConfig);
    Storage.set('motopikis_country', selectedCountry);
  }, [selectedCountry]);

  // Autodetectar por IP si no se ha configurado un país previamente
  useEffect(() => {
    const hasPreselected = Storage.get('motopikis_country');
    if (!hasPreselected) {
      const detectCountry = async () => {
        try {
          const res = await fetch('https://ipapi.co/json/');
          if (res.ok) {
            const data = await res.json();
            const countryCode = data.country_code?.toUpperCase();
            if (countryCode && COUNTRIES_CONFIG[countryCode]) {
              setSelectedCountry(countryCode);
            }
          }
        } catch (e) {
          // Fallback silencioso a Colombia (CO)
          setSelectedCountry('CO');
        }
      };
      detectCountry();
    }
  }, []);

  const changeCountry = (code: string) => {
    if (COUNTRIES_CONFIG[code]) {
      setSelectedCountry(code);
    }
  };

  const validatePhone = (phone: string): boolean => {
    const cleaned = phone.replace(/\D/g, '');
    try {
      const parsed = parsePhoneNumberFromString(cleaned, config.code as any);
      return parsed ? parsed.isValid() : cleaned.length === config.phoneLength;
    } catch {
      return cleaned.length === config.phoneLength;
    }
  };

  const formatE164 = (phone: string): string => {
    const cleaned = phone.replace(/\D/g, '');
    try {
      const parsed = parsePhoneNumberFromString(cleaned, config.code as any);
      if (parsed && parsed.isValid()) {
        return parsed.format('E164').replace('+', '');
      }
    } catch {}
    return `${config.phonePrefix}${cleaned}`;
  };

  return {
    selectedCountry,
    config,
    changeCountry,
    validatePhone,
    formatE164,
    allCountries: Object.values(COUNTRIES_CONFIG)
  };
};
